/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-unresolved */
import React, { useState, useEffect, useMemo, useCallback } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Container, Box, Paper, Tabs, Tab, Badge, useTheme, useMediaQuery } from "@mui/material";
import { Home as HomeIcon, Inventory2 as ProductsIcon, ShoppingCart as CartIcon, Person as AccountIcon } from "@mui/icons-material";

import * as Actions from "actions";
import { isMarketPlace, getURI } from "helpers/utils";

// Import the common shop header
import ShopHeaderMini from "components/elements/main/ShopHeaderMini";
import FlutterStyleShopHeader from "./FlutterStyleShopHeader";

// Import tab content components
import ShopHomeTabContent from "./ShopHomeTabContent";
import ShopProductsTabContent from "./ShopProductsTabContent";
import ShopCartTabContent from "./ShopCartTabContent";
import ShopAccountTabContent from "./ShopAccountTabContent";

const ShopTabbedMain = (props) => {
    const { match, bootupInfo, shopinfo, history, cartItems } = props;
    const location = useLocation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const shopId = (isMarketPlace() ? match.params.shopId : bootupInfo.appState.subdomain_shopId);
    
    // Memoize the current page to prevent recalculation on every render
    const currentPage = useMemo(() => {
        const path = location.pathname;
        const pathArray = path.split("/");
        
        console.log('URL path:', path); // Debug log
        console.log('Path array:', pathArray); // Debug log
        
        // For marketplace: /shop/:shopId/...
        // For usersite: /...
        const baseIndex = process.env.REACT_APP_TYPE === "USERSITE" ? 0 : 2;
        const section = pathArray[baseIndex + 1] || "";
        const subsection = pathArray[baseIndex + 2] || "";
        const id = pathArray[baseIndex + 3] || "";
        
        console.log('Section:', section, 'Subsection:', subsection); // Debug log
        
        // Determine page type
        if (section === "products" && subsection && subsection !== "search" && subsection !== "sort") {
            // Keep product detail as part of products tab to show Flutter header
            return { type: "products-tab" };
        } else if (section === "cart" && subsection === "checkout") {
            // Keep checkout as part of cart tab to show Flutter header
            return { type: "cart-tab" };
        } else if (section === "cart" && subsection === "payment-page") {
            // Keep payment as part of cart tab to show Flutter header
            return { type: "cart-tab" };
        } else if (section === "cart" && subsection === "order-success") {
            // Keep order success as part of cart tab to show Flutter header
            return { type: "cart-tab" };
        } else if (section === "account" && subsection === "wishlist") {
            // Keep wishlist as part of account tab
            return { type: "account-tab" };
        } else if (section === "account" && subsection === "orders" && subsection) {
            // Keep order detail as part of account tab
            return { type: "account-tab" };
        } else if (section === "account" && subsection === "orders") {
            // Keep orders list as part of account tab
            return { type: "account-tab" };
        } else if (section === "account" && subsection === "appointments") {
            // Keep appointments as part of account tab
            return { type: "account-tab" };
        } else if (section === "account" && subsection === "mytryons") {
            // Keep tryon profile as part of account tab
            return { type: "account-tab" };
        } else if (section === "account" && subsection === "tryonprofile") {
            // Keep tryon profile as part of account tab
            return { type: "account-tab" };
        } else if (section === "products") {
            return { type: "products-tab" };
        } else if (section === "cart") {
            return { type: "cart-tab" };
        } else if (section === "account") {
            return { type: "account-tab" };
        } else {
            return { type: "home-tab" };
        }
    }, [location.pathname]);

    // Custom back handler - goes to shops search instead of browser history
    const handleCustomBack = useCallback(() => {
        if (isMarketPlace()) {
            history.push("/shops");
        } else {
            history.push("/");
        }
    }, [history]);

    // Determine if we should show tabs (only for main tab pages)
    const shouldShowTabs = useMemo(() => {
        const tabPages = ["home-tab", "products-tab", "cart-tab", "account-tab"];
        return tabPages.includes(currentPage.type);
    }, [currentPage.type]);

    // Determine if we should show Flutter-style header (only for main tab pages)
    const shouldShowFlutterHeader = useMemo(() => {
        const tabPages = ["home-tab", "products-tab", "cart-tab", "account-tab"];
        return tabPages.includes(currentPage.type);
    }, [currentPage.type]);

    // Get current tab for navigation
    const getCurrentTabIndex = useMemo(() => {
        switch (currentPage.type) {
            case "home-tab": return 0;
            case "products-tab": return 1;
            case "cart-tab": return 2;
            case "account-tab": return 3;
            default: return 0;
        }
    }, [currentPage.type]);

    const handleTabChange = useCallback((event, newValue) => {
        const basePath = isMarketPlace() ? `/shop/${shopId}` : '';
        switch (newValue) {
            case 0:
                history.push(basePath || '/');
                break;
            case 1:
                history.push(`${basePath}/products`);
                break;
            case 2:
                history.push(`${basePath}/cart`);
                break;
            case 3:
                history.push(`${basePath}/account`);
                break;
            default:
                break;
        }
    }, [history, shopId]);

    const cartItemCount = cartItems ? cartItems.length : 0;

    const renderPageContent = () => {
        console.log('Current page type:', currentPage.type); // Debug log
        switch (currentPage.type) {
            // Main tab pages
            case "home-tab":
                return <ShopHomeTabContent {...props} shopId={shopId} />;
            case "products-tab":
                return <ShopProductsTabContent {...props} shopId={shopId} location={location} history={history} />;
            case "cart-tab":
                return <ShopCartTabContent {...props} shopId={shopId} location={location} />;
            case "account-tab":
                return <ShopAccountTabContent {...props} shopId={shopId} location={location} />;
            
            // Other shop pages (outside of tabs) - None currently
            
            default:
                console.log('Default case, rendering home'); // Debug log
                return <ShopHomeTabContent {...props} shopId={shopId} />;
        }
    };

    // Render layout based on page type
    if (shouldShowFlutterHeader) {
        // Flutter-style layout for main tab pages
        return (
            <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column', 
                minHeight: '100vh',
                backgroundColor: '#f5f5f5'
            }}>
                {/* SEO Support */}
                <Helmet>
                    <title>{shopinfo.title}</title>
                    <meta name="description" content={shopinfo.title} />
                </Helmet>
                {/* SEO Support End */}

                {/* Red Header Section */}
                <Box sx={{
                    backgroundColor: '#E53E3E',
                    color: 'white',
                    position: 'relative'
                }}>
                    <FlutterStyleShopHeader 
                        {...props} 
                        shopId={shopId} 
                        onCancel={handleCustomBack}
                    />
                </Box>

                {/* Top Tab Navigation - Below Shop Header */}
                <Paper
                    sx={{
                        position: 'sticky',
                        top: 0,
                        zIndex: 1000,
                        borderBottom: '1px solid #e0e0e0',
                        borderRadius: 0,
                        backgroundColor: 'white'
                    }}
                    elevation={2}
                >
                    <Tabs
                        value={getCurrentTabIndex}
                        onChange={handleTabChange}
                        variant="fullWidth"
                        indicatorColor="primary"
                        textColor="primary"
                        sx={{
                            minHeight: 56,
                            '& .MuiTab-root': {
                                minHeight: 56,
                                fontSize: '0.875rem',
                                fontWeight: 500,
                                textTransform: 'none',
                                color: '#666',
                                '&.Mui-selected': {
                                    color: '#E53E3E',
                                    fontWeight: 600
                                }
                            },
                            '& .MuiTabs-indicator': {
                                height: 3,
                                backgroundColor: '#E53E3E',
                                borderRadius: '3px 3px 0 0'
                            }
                        }}
                    >
                        <Tab
                            icon={<HomeIcon sx={{ color: getCurrentTabIndex === 0 ? '#E53E3E' : '#666' }} />}
                            label="Home"
                            iconPosition="start"
                        />
                        <Tab
                            icon={<ProductsIcon sx={{ color: getCurrentTabIndex === 1 ? '#E53E3E' : '#666' }} />}
                            label="Products"
                            iconPosition="start"
                        />
                        <Tab
                            icon={
                                <Badge badgeContent={cartItemCount} color="error">
                                    <CartIcon sx={{ color: getCurrentTabIndex === 2 ? '#E53E3E' : '#666' }} />
                                </Badge>
                            }
                            label="Cart"
                            iconPosition="start"
                        />
                        <Tab
                            icon={<AccountIcon sx={{ color: getCurrentTabIndex === 3 ? '#E53E3E' : '#666' }} />}
                            label="Account"
                            iconPosition="start"
                        />
                    </Tabs>
                </Paper>

                {/* Main Content Area */}
                <Box sx={{ 
                    flex: 1, 
                    backgroundColor: '#fff',
                    minHeight: 'calc(100vh - 200px)'
                }}>
                    <Container maxWidth="lg" sx={{ py: 2 }}>
                        <Box sx={{ 
                            backgroundColor: 'white',
                            borderRadius: '8px',
                            p: 2,
                            minHeight: '400px'
                        }}>
                            {renderPageContent()}
                        </Box>
                    </Container>
                </Box>
            </Box>
        );
    } else {
        // Regular layout for other pages (checkout, product details, etc.)
        return (
            <Container>
                {/* SEO Support */}
                <Helmet>
                    <title>{shopinfo.title}</title>
                    <meta name="description" content={shopinfo.title} />
                </Helmet>
                {/* SEO Support End */}

                {/* Regular Shop Header */}
                <ShopHeaderMini 
                    {...props} 
                    shopId={shopId} 
                    excludeBackOnHome={process.env.REACT_APP_TYPE === "USERSITE"} 
                    includeNav={false}
                    onCancel={handleCustomBack}
                />

                {/* Page Content */}
                <Box sx={{ mt: 1 }}>
                    {renderPageContent()}
                </Box>
            </Container>
        );
    }
};

ShopTabbedMain.propTypes = {
    match: PropTypes.object.isRequired,
    bootupInfo: PropTypes.objectOf(PropTypes.any).isRequired,
    shopinfo: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    cartItems: PropTypes.arrayOf(PropTypes.object),
};

ShopTabbedMain.defaultProps = {
    cartItems: [],
};

const _ShopTabbedMain = connect(
    ({ bootupInfo, cartList }) => ({
        bootupInfo,
        shopinfo: bootupInfo.shopinfo,
        cartItems: cartList.cart || [],
    }),
    (dispatch) => bindActionCreators({ ...Actions }, dispatch),
)(ShopTabbedMain);

export { _ShopTabbedMain as default };
